/** Route state that opens the App Builder with text for its chat, sent at once when `send` is set. */
export interface BuilderRouteState {
  readonly prefill: string;
  readonly send?: boolean;
}

export interface BuilderPrefill {
  readonly text: string;
  readonly send: boolean;
}

export const prefillOf = (state: unknown): BuilderPrefill | null => {
  if (typeof state !== 'object' || state === null) return null;
  const { prefill, send } = state as Partial<Record<keyof BuilderRouteState, unknown>>;
  return typeof prefill === 'string' && prefill.trim() ? { text: prefill, send: send === true } : null;
};
